import React from 'react';
import { AnimatePresence, LazyMotion, m, domAnimation } from 'framer-motion';

const OpenCloseAnimation = ({ className, children, duration = 0.3, isOpen }: OpenCloseAnimationProps) => (
	<AnimatePresence initial={false}>
		{isOpen && (
			<LazyMotion features={domAnimation}>
				<m.div
					style={{ overflow: 'hidden', height: 0 }}
					animate={{
						height: 'auto',
						transitionEnd: {
							overflow: 'initial',
						},
					}}
					transition={{ duration }}
					className={className}
					exit={{ height: 0, overflow: 'hidden' }}
				>
					{children}
				</m.div>
			</LazyMotion>
		)}
	</AnimatePresence>
);

export default OpenCloseAnimation;

export interface OpenCloseAnimationProps {
	className?: string;
	duration?: number; // seconds
	isOpen: boolean;
	children: React.ReactNode;
}
